import { PostRequest } from "./http/BaseRequest";

export class DeleteNoteRequest extends PostRequest {
  constructor(id: string | number) {
    super("/note/delete", { id });
  }
}